module.exports = __webpack_public_path__ + "img/our4.0bc3d7fc.svg";